export const execute = (repository) => () => {
    return repository.getAll()
        .then(sort)
}

const sort = (serviceCategories) => {
    return serviceCategories.sort((s1, s2) => s1.name.toLowerCase() > s2.name.toLowerCase() ? 1 : -1);
};
